import {connect} from 'react-redux';
import {VttSubtitle} from '@accurate-player/accurate-player-plugins';
import {EnabledSubtitles} from 'VideoAudioQC/Timeline/SubtitleTracks/Redux/SubtitleTracksReducer';
import {
    SelectNextPreviousMarker,
    selectNextPreviousMarkerAction,
    ToggleSelectedMarker,
    toggleSelectedMarkerAction,
} from 'VideoAudioQC/Timeline/Redux/TimelineActions';
import {QCTabsState} from 'VideoAudioQC/QCTabs/Redux/QCTabsReducer';
import {TabIndex} from 'VideoAudioQC/QCTabs/QCTabsTypes';
import {TimelineState} from 'VideoAudioQC/Timeline/Redux/TimelineReducer';
import {QCMediaState} from 'VideoAudioQC/QCMedia/Redux/QCMediaReducer';
import {Item} from 'VideoAudioQC/QCMedia/Redux/QCMediaActions';
import {TimedText} from '@pluto/rest/lib/qc-types';
import {TimelineMarker, TimelineRowType} from 'VideoAudioQC/Timeline/TimelineTypes';
import {SetActiveTab, setActiveTabAction} from 'VideoAudioQC/QCTabs/Redux/QCTabsActions';
import AccuratePlayerContainer from './AccuratePlayerContainer';
import {
    setPlayerStatusAction,
    SetPlayerStatus,
    setAdPreviewsAction,
    SetAdPreview,
    SetShowHotkeys,
    setShowHotkeysAction,
} from './Redux/AccuratePlayerActions';
import {
    DisableAllSubtitles,
    disableAllSubtitlesAction,
} from '../Timeline/SubtitleTracks/Redux/SubtitleTracksActions';
import {AdPreview} from './AccuratePlayerTypes';
import {AccuratePlayerState} from './Redux/AccuratePlayerReducer';

interface StateProps {
    subtitles: VttSubtitle[];
    enabledSubtitles: EnabledSubtitles;
    adPreviews?: AdPreview[];
    showHotkeys: boolean;
    showSafeMargins: boolean;
    adOnPlayingFrame?: TimelineMarker;
    activeTab: TabIndex;
    selectedRowId: string;
    selectedMarkerId: string;
    selectedType: TimelineRowType;
    qcReportRowId: string;
    adBreaksRowId: string;
    markupRowId: string;
}

interface DispatchProps {
    setPlayerStatusAction: SetPlayerStatus;
    disableAllSubtitles: DisableAllSubtitles;
    setAdPreviews: SetAdPreview;
    setShowHotkeys: SetShowHotkeys;
    selectNextPreviousMarker: SelectNextPreviousMarker;
    setActiveTab: SetActiveTab;
    toggleSelectedMarker: ToggleSelectedMarker;
}

export type State = {
    subtitles: {
        enabled: EnabledSubtitles;
    };
    videoAudioQC: {
        qcMedia: QCMediaState;
        accuratePlayer: AccuratePlayerState;
        qcTabs: QCTabsState;
    };
    timeline: {
        adBreaks: {
            rowId: string;
        };
        markup: {
            rowId: string;
        };
        selectedMarker: TimelineState;
        qcReport: {
            rowId: string;
        };
    };
};

export const mapSubtitle = (timedText: TimedText): VttSubtitle => {
    const {language, timedTextUrl} = timedText;
    const src = timedTextUrl;
    const label = language;
    const srclang = language;

    return {
        kind: 'subtitles',
        label,
        srclang,
        src,
        enabled: false,
    };
};

export const parseSubtitles = (item: Item | null): VttSubtitle[] => {
    if (!item) return [];

    return item.timedTexts?.map(mapSubtitle);
};

export const mapState = (state: State): StateProps => {
    const {timeline, videoAudioQC} = state;
    const {enabled} = state.subtitles;
    const {accuratePlayer, qcTabs, qcMedia} = videoAudioQC;
    const {selectedMarker, adBreaks, qcReport, markup} = timeline;
    const {selectedType, selectedMarkerId, selectedRowId} = selectedMarker;
    const {adPreviews, showHotkeys, adOnPlayingFrame, showSafeMargins} = accuratePlayer;
    const {activeTab} = qcTabs;
    const qcReportRowId = qcReport.rowId;
    const adBreaksRowId = adBreaks.rowId;
    const markupRowId = markup.rowId;
    const {item} = qcMedia;
    const subtitles = parseSubtitles(item);

    return {
        subtitles,
        enabledSubtitles: enabled,
        adPreviews,
        showHotkeys,
        showSafeMargins,
        adOnPlayingFrame,
        activeTab,
        selectedRowId,
        selectedType,
        selectedMarkerId,
        qcReportRowId,
        adBreaksRowId,
        markupRowId,
    };
};

export const mapDispatch: DispatchProps = {
    setPlayerStatusAction,
    disableAllSubtitles: disableAllSubtitlesAction,
    setAdPreviews: setAdPreviewsAction,
    setShowHotkeys: setShowHotkeysAction,
    selectNextPreviousMarker: selectNextPreviousMarkerAction,
    setActiveTab: setActiveTabAction,
    toggleSelectedMarker: toggleSelectedMarkerAction,
};

export default connect(mapState, mapDispatch)(AccuratePlayerContainer);
